import { AxiosResponse } from "axios";
import { getAxiosInstance, requestConfig } from "../../http-common";
import { CreateViewRequest } from "../../models/ExcelAddin/CreateViewRequest";
import { UpdateViewRequest } from "../../models/ExcelAddin/UpdateViewRequest";
import {Entity} from "../../models/entities/Entity";

const RESOURCE_NAME = "Views";

const getAll = () : Promise<AxiosResponse> => {
  const http = getAxiosInstance();
  let url = `${RESOURCE_NAME}`
  return http.get(url, requestConfig());
};

const getByEnitityId = (selectedEnitityId: number) : Promise<AxiosResponse> => {
  const http = getAxiosInstance();
  let url = `${RESOURCE_NAME}?entityId=${selectedEnitityId}`
  return http.get(url, requestConfig());
};

const update = (id: number,data: UpdateViewRequest) : Promise<AxiosResponse> => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/${id}`, data, requestConfig());
}

const create = (data: CreateViewRequest) : Promise<AxiosResponse> => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}`, data, requestConfig());
}

const remove = (id: number) : Promise<AxiosResponse> => {
  const http = getAxiosInstance();
  return http.delete(`${RESOURCE_NAME}/${id}`, requestConfig());
}

const getFields = (viewId: number) : Promise<AxiosResponse> => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/${viewId}/fields`, requestConfig());
}

const getAllViewTypes = () => {
    const http = getAxiosInstance();
    return http.get<Entity[]>(`${RESOURCE_NAME}/getAllViewTypes`, requestConfig());
};

const ViewsService = {
    getAll,
    getByEnitityId,
    getAllViewTypes,
    update,
    create,
    remove,
    getFields
}

export default ViewsService;